export default "__VITE_ASSET__DxeL2VL___"